import IframeMessageBroker from '@flywire/internal-components/services/iframeMessageBroker/iframeMessageBroker';
import type { InjectDocumentCollectorAppearanceSettings } from '@flywire/internal-components/services/iframeMessageBroker/model';
import { MESSAGES } from '@flywire/internal-components/services/iframeMessageBroker/model';

import {
  type DocumentCollectorElementPublicOptions,
  type InternalElementFactoryOptions,
  SdkElement
} from '../../../model';
import { EventBus, type EventBusType } from '../../EventBus';
import { createIframe } from '../createIframe';
import { documentCollectorUrlBuilder } from './documentCollectorUrlBuilder';

export type DocumentCollectorElementOptions = DocumentCollectorElementPublicOptions &
  InternalElementFactoryOptions;

export const DocumentCollectorElement = (options: DocumentCollectorElementOptions): SdkElement => {
  const { displayMode = 'full-screen' } = options;
  const eventBus = EventBus();

  const mount = (id?: string) => {
    const url = documentCollectorUrlBuilder(options);
    const { iframe } = createIframe({
      containerId: id,
      src: url,
      displayMode,
      title: 'Flywire Document Collector Element',
      containerErrorKey: 'documentCollectorElementContainerNotPresent'
    });

    sendAppearanceValuesToIframe(
      IframeMessageBroker.getInstance(),
      iframe,
      options.appearance,
      eventBus
    );
  };

  return {
    mount,
    onEvent: (key, fn) => eventBus.addEvent(key, fn),
    registeredEvents: eventBus.registeredEvents
  };
};

const sendAppearanceValuesToIframe = (
  broker: ReturnType<(typeof IframeMessageBroker)['getInstance']>,
  iframe: HTMLIFrameElement,
  appearance: InternalElementFactoryOptions['appearance'],
  eventBus: EventBusType
) => {
  broker.addListener(MESSAGES.DOCUMENT_COLLECTOR_ELEMENT_LOADED, () => {
    eventBus.onEvent('loaded', {});
    if (appearance) {
      broker.sendMessage<InjectDocumentCollectorAppearanceSettings>(
        MESSAGES.INJECT_DOCUMENT_COLLECTOR_APPEARANCE_SETTINGS,
        { appearance: { ...appearance } },
        iframe
      );
    }
  });
};
